import React from "react";
import { Container, Row, Col } from "shards-react";
import AuthorizationMatrices from "../components/contracts/authorizationMatrices/authorizationMatrices";

const AuthorizationMatricesTable = () => (
  <Container fluid className="main-content-container px-4">
	  <Row>
      <Col className="p-2">
		    <AuthorizationMatrices /> 
      </Col>
    </Row>
   </Container>
);

export default AuthorizationMatricesTable;
